/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { v4 as uuid } from 'uuid';
import { Table } from 'react-bootstrap';
import { Field } from 'redux-form';
import { LEARNING_ASSET_TYPES } from '../../../../../shared/Constants';

import BasicSelect from '../../../../../shared/components/formComponents/groups/BasicSelect';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../shared/components/VerbButton';

class RenderParticipants extends Component {
    static propTypes = {
        fields: PropTypes.any,
        type: PropTypes.oneOf([
            LEARNING_ASSET_TYPES.TRACK,
            LEARNING_ASSET_TYPES.ACTIVITY,
            LEARNING_ASSET_TYPES.ARTICLE,
            LEARNING_ASSET_TYPES.SINGLE_PAGE_ACTIVITY,
            LEARNING_ASSET_TYPES.VIDEO,
            LEARNING_ASSET_TYPES.IMPACT_PROJECT,
            LEARNING_ASSET_TYPES.ASSESSMENT,
            LEARNING_ASSET_TYPES.PRE_ASSESSMENT,
            LEARNING_ASSET_TYPES.POST_ASSESSMENT,
            LEARNING_ASSET_TYPES.FEEDBACK
        ]).isRequired,
        participantsDataSource: PropTypes.array
    };

    UNSAFE_componentWillMount() {
        this._populateFields();
    }

    _populateFields = () => {
        const { type, fields } = this.props;
        if (type === LEARNING_ASSET_TYPES.FEEDBACK && fields.length <= 1) {
            this._populateFieldsForFeedbackType(fields);
        }
    };

    _populateFieldsForFeedbackType = (fields) => {
        fields.removeAll();
        fields.push({ id: uuid(), type: 'employee' });
        fields.push({ id: uuid(), type: 'colleague' });
        fields.push({ id: uuid(), type: 'colleague' });
        fields.push({ id: uuid(), type: 'colleague' });
    };

    render() {
        const { fields, participantsDataSource } = this.props;
        const renderedParticipants = fields.map((member, index) => (
            <tr key={index}>
                <td className={'buttonCell'}>
                    <VerbButton
                        buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                        fontAwesomeIcon={'fa-trash'}
                        title={'Remove Participant'}
                        onClick={() => fields.remove(index)}
                    />
                </td>
                <td>User {index + 1}</td>
                <td>
                    <Field
                        name={`${member}.type`}
                        options={participantsDataSource}
                        displayHelp={false}
                        component={BasicSelect}
                    />
                </td>
            </tr>
        ));

        return (
            <div className={cns('form-group', 'trackParticipantsSection')}>
                <label>Participants: {fields.length}</label>
                <Table responsive={true}>
                    <thead>
                        <tr>
                            <th className={'buttonCell'} style={{ width: '16.66667%' }}>
                                Actions
                            </th>
                            <th>User</th>
                            <th>Role</th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderedParticipants}
                        <tr key={'addNewParticipant'}>
                            <td>
                                <VerbButton
                                    onClick={() => {
                                        fields.push({ id: uuid(), type: '' });
                                    }}
                                    buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                                    fontAwesomeIcon={'fa-plus'}
                                >
                                    Add Participant
                                </VerbButton>
                            </td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default RenderParticipants;
